import React from 'react';

import BaseComponent from 'src/components/BaseComponent';

import constants from 'src/constants';

import { lang, withRouter, addressObject } from 'src/helpers';

import model from './model';

class AddAdvance extends BaseComponent {
  state = { more: false };

  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    const createState = model.getApiState(this.props.apiStateId);

    const address = addressObject(model.state);
    return (
      <div className={`mc-form mc-tab-content`}>
        <div className={'mc-flex-col mc-grow'}>
          {createState.error && <p className='mc-error'>{createState.errorMessage}</p>}
          {[
            [
              {
                type: 'input',
                name: 'firstName',
                label: 'First Name',
                placeholder: 'Enter patient first name'
              },
              {
                type: 'input',
                name: 'lastName',
                label: 'Last Name',
                placeholder: 'Enter patient last name'
              }
            ],
            [
              {
                type: 'phone',
                name: 'phoneNumber',
                label: 'Phone Number',
                placeholder: 'Enter patient phone number'
              },
              {
                type: 'input',
                name: 'email',
                label: 'Email Address',
                placeholder: 'Enter patient email address'
              }
            ],
            [
              {
                type: 'select',
                name: 'gender',
                label: 'Gender',
                options: constants.general.gender,
                placeholder: 'Select gender'
              },
              {}
            ],
            [
              {
                type: 'birthday',
                name: 'birthday',
                label: 'Date of birth'
              }
            ]
            // [
            //   {
            //     type: 'select',
            //     name: 'referralSource',
            //     label: 'Referral Source',
            //     options: []
            //   }
            // ]
          ].map((row, i) => this.props.renderRow(row, i))}
          <div className={'mc-title'}>{lang.t('Contact information')}</div>
          {[
            [
              {
                type: 'areainput',
                name: 'address',
                label: 'Address',
                placeholder: 'Enter patient address'
              }
            ],
            [
              {
                type: 'autocomplete',
                name: 'countryAddress',
                label: 'Country',
                props: {
                  autocompleteApi: 'country',
                  autocompleteParams: {
                    limit: 300
                  }
                }
              },
              {
                type: 'autocomplete',
                name: 'stateAddress',
                label: 'State',
                props: {
                  autocompleteApi: 'state',
                  autocompleteParams: {
                    countryCode: address.countryCode,
                    limit: 100
                  }
                }
              },
              {
                type: 'autocomplete',
                name: 'cityAddress',
                label: 'City',
                props: {
                  autocompleteApi: 'city',
                  autocompleteParams: {
                    countryCode: address.countryCode,
                    stateCode: address.stateCode,
                    limit: 20
                  }
                }
              }
            ],
            [
              {
                type: 'input',
                name: 'zipcode',
                label: 'Zip',
                placeholder: 'Enter zip code'
              }
            ]
          ].map((row, i) => this.props.renderRow(row, i))}
          <div>&nbsp;</div>

          {/*<div className={'mc-form-right'}>*/}
          {/*  <div className={'mc-flex'}>*/}
          {/*    <div className={'mc-grow mc-title'}>{lang.t('Schedule appointment')}</div>*/}
          {/*    <ToggleSwitch*/}
          {/*        checked={model.input('scheduleFlg')}*/}
          {/*        onChange={() => model.handleChange('scheduleFlg', !model.input('scheduleFlg'))}*/}
          {/*    />*/}
          {/*  </div>*/}
          {/*  {model.input('scheduleFlg') && (*/}
          {/*      <>*/}
          {/*        {model.state.user?.isClinic && (*/}
          {/*            <SelectField*/}
          {/*                template={6}*/}
          {/*                isClearable={false}*/}
          {/*                isAsync={true}*/}
          {/*                loadOptions={model.loadDoctors}*/}
          {/*                placeholder={'Doctor'}*/}
          {/*                defaultOptions={model.state.doctors}*/}
          {/*                name={'doctorId'}*/}
          {/*                invalid={invalid}*/}
          {/*                value={model.input('doctorId')}*/}
          {/*                onChange={(n, v, a) => {*/}
          {/*                  model.handleChange('doctorId', v);*/}
          {/*                  model.selectedMonth(model.state.selectedDate);*/}
          {/*                }}*/}
          {/*            />*/}
          {/*        )}*/}
          {/*        <MCDatePicker*/}
          {/*            selected={model.input('selectedDate')}*/}
          {/*            isSmall={true}*/}
          {/*            minDate={moment()}*/}
          {/*            onChange={model.selectedDay}*/}
          {/*            onSetMonth={model.selectedMonth}*/}
          {/*            onClassNamesOfCell={(day, classNames) => {*/}
          {/*              if (*/}
          {/*                  model.state.slotsMonth.find(*/}
          {/*                      (s) =>*/}
          {/*                          s.startDate >= day.clone().startOf('day') &&*/}
          {/*                          s.startDate <= day.clone().endOf('day')*/}
          {/*                  )*/}
          {/*              ) {*/}
          {/*                classNames.push('available');*/}
          {/*              }*/}
          {/*            }}*/}
          {/*        />*/}
          {/*        <div className={'mc-title'}>{lang.t('Time')}</div>*/}
          {/*        {model.state.slots*/}
          {/*            .slice(0, this.state.more ? model.state.slots.length : 5)*/}
          {/*            .map((s, i) => {*/}
          {/*              const slot =*/}
          {/*                  s.id !== model.state.selectedSlot?.id*/}
          {/*                      ? s*/}
          {/*                      : {*/}
          {/*                        ...model.state.selectedSlot,*/}
          {/*                        patientId: 'temp',*/}
          {/*                        firstName: model.state.firstName || '',*/}
          {/*                        lastName: model.state.lastName || ''*/}
          {/*                      };*/}
          {/*              return (*/}
          {/*                  <div className={'mc-flex-col'} key={i}>*/}
          {/*                    <div className={'mc-title'}>{moment(slot.startDate).format('hh:mm a')}</div>*/}
          {/*                    {!slot.patientId && (*/}
          {/*                        <div*/}
          {/*                            className={'mc-slot available mc-no-style-btn'}*/}
          {/*                            onClick={() => {*/}
          {/*                              popupModel.setActivePopup('add_patient_slot', {*/}
          {/*                                active: true,*/}
          {/*                                component: AddPatientSlot,*/}
          {/*                                props: {item: slot, index: i}*/}
          {/*                              });*/}
          {/*                            }}*/}
          {/*                        >*/}
          {/*                          <div className={'mc-flex'}>*/}
          {/*                            <div className={'mc-icon'}>*/}
          {/*                              <SVGIcon*/}
          {/*                                  iconname={'plus-icon'}*/}
          {/*                                  width={12}*/}
          {/*                                  fill={variables['colors-mc-text-primary']}*/}
          {/*                              />*/}
          {/*                            </div>*/}
          {/*                            <div>{lang.t('Add Patient')}</div>*/}
          {/*                          </div>*/}
          {/*                        </div>*/}
          {/*                    )}*/}
          {/*                    {!!slot.patientId && (*/}
          {/*                        <div className={'mc-slot ' + slot.appointmentType}>*/}
          {/*                          {slot.patientId === 'temp' && (*/}
          {/*                              <CloseBtn*/}
          {/*                                  onClose={() => model.setState({selectedSlot: null})}*/}
          {/*                                  width={20}*/}
          {/*                                  style={{position: 'absolute', right: remCss(15), top: remCss(15)}}*/}
          {/*                              />*/}
          {/*                          )}*/}
          {/*                          <div className={'mc-flex'}>*/}
          {/*                            {constants.general.appointment_types*/}
          {/*                                .filter((i) => slot.appointmentType === i.value)*/}
          {/*                                .map((i) => (*/}
          {/*                                    <div className={'mc-tag'} key={i.value}>*/}
          {/*                                      {lang.t(i.label)}*/}
          {/*                                    </div>*/}
          {/*                                ))}*/}
          {/*                          </div>*/}

          {/*                          <div className={'mc-flex'}>*/}
          {/*                            <Avatar*/}
          {/*                                image={slot.avatar}*/}
          {/*                                text={slot.firstName}*/}
          {/*                                width={40}*/}
          {/*                                height={40}*/}
          {/*                            />*/}
          {/*                            <div className={'mc-title'}>{userFullName(slot)}</div>*/}
          {/*                          </div>*/}
          {/*                          {slot.hospital && (*/}
          {/*                              <div className={'mc-flex'}>*/}
          {/*                                {slot.hospital?.split('_')[0]}, {upperFirstChar(slot.cityAddress)}*/}
          {/*                              </div>*/}
          {/*                          )}*/}
          {/*                        </div>*/}
          {/*                    )}*/}
          {/*                  </div>*/}
          {/*              );*/}
          {/*            })}*/}
          {/*      </>*/}
          {/*  )}*/}
          {/*  {model.getApiState('list').loading ? (*/}
          {/*      <div>*/}
          {/*        <Spinner/>*/}
          {/*      </div>*/}
          {/*  ) : (*/}
          {/*      model.input('scheduleFlg') && (*/}
          {/*          <>*/}
          {/*            {model.state.slots.length > 5 && (*/}
          {/*                <div className={'mc-flex'}>*/}
          {/*                  <div className={'mc-grow'}></div>*/}
          {/*                  <div*/}
          {/*                      className={'mc-more'}*/}
          {/*                      onClick={() => this.setState({more: !this.state.more})}*/}
          {/*                  >*/}
          {/*                    <span className={'mc-char'}>{!this.state.more ? '+' : '-'}</span>*/}
          {/*                    &nbsp;&nbsp;*/}
          {/*                    {lang.t(!this.state.more ? 'Show more' : 'Show less')}*/}
          {/*                  </div>*/}
          {/*                </div>*/}
          {/*            )}*/}
          {/*            {model.state.slots.length === 0 && (*/}
          {/*                <div style={{textAlign: 'center'}}>{lang.t('No available slot.')}</div>*/}
          {/*            )}*/}
          {/*          </>*/}
          {/*      )*/}
          {/*  )}*/}
          {/*  <div>&nbsp;</div>*/}
          {/*</div>*/}
        </div>
      </div>
    );
  }
}

export default withRouter(AddAdvance);
